import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';

const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  }),
  withCredentials: true
};

export interface AttributeInfoRow {
  CODE_KEY?: number;
  CODE_DESCRIPTION?: string;
  CODE_GROUP?: string;
}

export type AttributeInfoLabel = 'Base Basket' | 'Base Type' | 'Base FDII' | 'Tax Year/Scenario';

@Injectable({ providedIn: 'root' })
export class AttributeSetUpInfoService {

  private actionCodes: Record<AttributeInfoLabel, string> = {
    'Base Basket': 'pbh5uq',
    'Base Type': '8ca0bw',
    'Base FDII': '8blhrv',
    'Tax Year/Scenario': '42j8ev',
  };

  constructor(private http: HttpClient) {}

  getBaseDataInfo(
    baseUrl: string,
    label: AttributeInfoLabel,
    tagKey: string,
    issueId: string,
    ssoId: string,
    taxYear: string,
    scenario: string,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<AttributeInfoRow[]> {
    const actionCode = this.actionCodes[label];

    if (!actionCode) {
      return throwError(() => new Error(`Unknown label: ${label}`));
    }

    const url = `${baseUrl}/loadJsonObject?action_code=${actionCode}`;
    const body = this.buildFormData(
      {
        sso_id: ssoId,
        tax_year: taxYear,
        scenario: scenario,
        tag_key: tagKey,
        issue_id: issueId,
      },
      globalParams,
      filterParams
    );

    return this.http.post<any>(url, body, HTTP_OPTIONS).pipe(
      map((res: any) => {
        if (res.callSuccess === '1') {
          return res.jsonObject || [];
        }
        return [];
      }),
      catchError(error => {
        console.error('Error fetching attribute info:', error);
        return throwError(() => error);
      })
    );
  }

  private buildFormData(
    params: { [key: string]: string },
    globalParams: any,
    filterParams: any
  ): HttpParams {
    const mergedParams: { [key: string]: string } = {};

    if (globalParams) {
      Object.keys(globalParams).forEach(key => {
        const value = globalParams[key];
        if (value !== undefined && value !== null && value !== '') {
          mergedParams[key] = String(value);
        }
      });
    }

    if (filterParams) {
      Object.keys(filterParams).forEach(key => {
        const value = filterParams[key];
        if (value !== undefined && value !== null && value !== '') {
          mergedParams[key] = String(value);
        }
      });
    }

    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        mergedParams[key] = params[key];
      }
    });

    let httpParams = new HttpParams();
    Object.keys(mergedParams).forEach(key => {
      httpParams = httpParams.set(key, mergedParams[key]);
    });

    return httpParams;
  }
}
